module.exports = __webpack_public_path__ + "img/signup-guide-05-02.7f654a9e.png";